import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/code-puncher/code-puncher-slot.js'

const tagName = 'dap-ds-code-puncher-slot'

/**
 * `dap-ds-code-puncher-slot`
 * @summary Individual digit input slot for code puncher.
 * @element dap-ds-code-puncher-slot
 * @title - Code puncher slot
 *
 * @csspart base - The slot container.
 * @csspart input - The input element.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSCodePuncherSlot',
})

export default reactWrapper
